import { useContext } from "react";
import { Thead, THT, THTS } from "../../components";
import TableContext from "../Provider/TableContext";

function TableHead() {
  const { setOrder = () => {} } = useContext(TableContext);

  return (
    <Thead>
     <THTS txt="DEVICE ID" field="device_id" setOrder={setOrder} />
<THTS txt="SIM CARD NO" field="sim_card_no" setOrder={setOrder} />
<THTS txt="IMEI" field="imei" setOrder={setOrder} />
<THTS txt="MAC Address" field="mac_address" setOrder={setOrder} />
<THTS txt="DEVICE TYPE ID" field="device_type_id" setOrder={setOrder} />
{/* <THTS txt="Created At" field="created_at" setOrder={setOrder} /> */}
{/* <THTS txt="Updated At" field="updated_at" setOrder={setOrder} /> */}
{/* <THTS txt="FGUID" field="fguid" setOrder={setOrder} /> */}
{/* <THTS txt="Device Deactivation" field="device_deactivation" setOrder={setOrder} /> */}
{/* <THTS txt="Vehicle Devices" field="vehicle_devices" setOrder={setOrder} /> */}
      
      <THT txt="Actions" />
    </Thead>
  );
}

export default TableHead;
